import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HotelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hotel"}/>
}
